import { useIntl } from "react-intl"

export function useNonEnglishLocaleSelectedMapper() {
  const intl = useIntl()
  const isNonEnglishLocale = !intl.locale.startsWith("en")

  return {
    // This is a read-only field. Use the locale selector to change the locale
    // or select a locale in the Dynamic Content Tool to update the value
    is_non_english_locale_selected: {
      value: isNonEnglishLocale,
      toggle: () => {}
    }
  }
}
